import React, { useEffect }  from 'react';
import Uom from './Uom';
import CableType from './CableType';
import Post from './Post';
import UserProfile from './UserProfile';
import CardBox from 'components/CardBox';
import axios from "axios";
import {
  NotificationContainer,
  NotificationManager,
} from "react-notifications";

import IntlMessages from "util/IntlMessages";
import PipeLenght from './PipeLenght';
import SliderImage from './SliderImage';
import Knowledge from './Knowledge';

// import PickGoogleMap from './PickGoogleMap';

const Setting = ({match}) => { 
  document.title = "AMO Water Management System - Setting";
  useEffect(() => {
    checkToken();
  }, []);
  const checkToken = async () => {
    var id = JSON.parse(localStorage.getItem("UserData")).id;
    var system = JSON.parse(localStorage.getItem("UserData")).system;
    var belongto = JSON.parse(localStorage.getItem("UserData")).belongto;
    var data = [id, system, belongto];
    axios
      .post("api/checkToken", data)
      .then((res) => {
        // console.log('result of auth', res.data);
        if (res.data.toString() === "unauthenticated") {
          localStorage.removeItem("token");
          this.props.history.push("/signin");
        } 
      })
      .catch((err) => {
        NotificationManager.error(
          <IntlMessages id="notification.errorMessage" />,
          <IntlMessages id="notification.titleHere" />
        );
      });
  };
  return (
      <div className="app-wrapper">
          {Number(JSON.parse(localStorage.getItem('UserData')).system) !== Number(1) ?
            <div className="row custom-row-card">
                <CardBox >
                  <UserProfile/>
                </CardBox>
            </div>
            :''
          }

          {Number(JSON.parse(localStorage.getItem('UserData')).system) === Number(1) ? (
          <div className="row seeting-table-style">

              <div className="col-xl-4 col-lg-6 col-md-6 col-12">
                <Uom  />
              </div>  
              <div className="col-xl-4 col-lg-6 col-md-6 col-12">
                <CableType />
              </div>
              <div className="col-xl-4 col-lg-6 col-md-6 col-12">
                <PipeLenght />
              </div>
              <div className="col-xl-6 col-lg-6 col-md-12 col-12">
                <Post />
              </div>
              <div className="col-xl-6 col-lg-6 col-md-12 col-12">
                <SliderImage />
              </div>
              <div className="col-xl-6 col-lg-6 col-md-12 col-12">
                <Knowledge />
              </div>
              {/* <div className="col-xl-12 col-lg-6 col-md-6 col-12">
                <PickGoogleMap />
              </div> */}

              
              
          </div>
          ) : ''}
          <NotificationContainer />
    </div>
  );
};
export default Setting;
